import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { planosApi } from '../../api/endpoints'
import { Header } from './Header'
import { Footer } from './Footer'
import { CookieBanner } from './CookieBanner'
import { css } from './css'

const CHECK = (
  <svg viewBox="0 0 20 20" width={16} height={16} fill="none" stroke="#3AC17E" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 2 }}>
    <path d="M4 10.5 8 14l8-8" />
  </svg>
)
const CRUZ = (
  <svg viewBox="0 0 20 20" width={16} height={16} fill="none" stroke="#6B7691" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 2 }}>
    <path d="M5 5l10 10M15 5 5 15" />
  </svg>
)

const FEATURES_PAGAS_BASE = [
  'Contas, cartões, metas e orçamentos ilimitados',
  'Conexão automática com bancos, com mais atualizações manuais por dia',
  'Relatórios avançados e exportação de dados',
  'Notas fiscais e recorrências',
  'Notificações em tempo real',
]

function Item({ icone, texto, apagado }: { icone: React.ReactNode; texto: string; apagado?: boolean }) {
  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', opacity: apagado ? 0.4 : 1 }}>
      {icone}
      <span style={{ color: apagado ? '#6B7691' : '#DCE1EC', fontSize: 13.5 }}>{texto}</span>
    </div>
  )
}

export function PrecosPage() {
  const [anual, setAnual] = useState(false)
  const { data: planos = [] } = useQuery({ queryKey: ['planos'], queryFn: planosApi.list })

  const premium = planos.find((p) => p.codigo === 'PREMIUM')
  const pro = planos.find((p) => p.codigo === 'PRO')
  const precoPremium = premium ? (anual ? premium.precoAnual : premium.precoMensal) : null
  const precoPro = pro ? (anual ? pro.precoAnual : pro.precoMensal) : null
  const fmt = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

  return (
    <div style={css('width: 100%; min-height: 100vh; background: #0B1220; display: flex; flex-direction: column;')}>
      <Header atual="precos" />

      <div style={css('max-width: 800px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 72px 32px 12px; text-align: center; display: flex; flex-direction: column; gap: 12px; align-items: center;')}>
        <span style={css('color: #F5A623; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px;')}>Preços</span>
        <h1 style={css('margin: 0; color: #FFFFFF; font-size: 34px; font-weight: 800;')}>Um plano para cada momento</h1>
        <p style={css('margin: 0; color: #A8B0C3; font-size: 15px; line-height: 1.6; max-width: 520px;')}>
          A conexão automática com bancos pelo Open Finance está disponível em <strong style={{ color: '#DCE1EC' }}>todos os planos, inclusive no gratuito</strong>. O que muda é quantas atualizações
          manuais por dia e outros limites de uso da plataforma.
        </p>

        <div style={css('display: inline-flex; background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 4px; margin-top: 8px;')}>
          <button onClick={() => setAnual(false)} style={css(`font-size: 13px; font-weight: 600; padding: 8px 18px; border-radius: 8px; cursor: pointer; border: none; background: ${anual ? 'transparent' : '#F5A623'}; color: ${anual ? '#A8B0C3' : '#0B1220'};`)}>Mensal</button>
          <button onClick={() => setAnual(true)} style={css(`font-size: 13px; font-weight: 600; padding: 8px 18px; border-radius: 8px; cursor: pointer; border: none; background: ${anual ? '#F5A623' : 'transparent'}; color: ${anual ? '#0B1220' : '#A8B0C3'};`)}>Anual — economize ~16%</button>
        </div>
      </div>

      <div style={css('max-width: 1100px; margin: 0 auto; width: 100%; box-sizing: border-box; padding: 40px 32px 96px;')}>
        <div style={css('display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; align-items: stretch;')}>

          <div style={css('background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 32px; display: flex; flex-direction: column; gap: 20px;')}>
            <div>
              <div style={css('color: #FFFFFF; font-size: 18px; font-weight: 800;')}>Grátis</div>
              <div style={css('color: #8892A8; font-size: 13px; margin-top: 4px;')}>Pra começar a organizar sua vida financeira.</div>
            </div>
            <div><span style={css('color: #FFFFFF; font-size: 36px; font-weight: 800;')}>R$ 0</span><span style={css('color: #6B7691; font-size: 13px;')}>/sempre</span></div>
            <Link to="/criar-conta" style={css('text-align: center; border: 1px solid rgba(255,255,255,0.18); color: #FFFFFF; font-weight: 700; font-size: 14px; padding: 12px; border-radius: 9px; text-decoration: none;')}>Criar conta grátis</Link>
            <div style={css('height: 1px; background: rgba(255,255,255,0.08);')} />
            <div style={css('display: flex; flex-direction: column; gap: 12px;')}>
              <Item icone={CHECK} texto="Até 3 contas e 1 cartão" />
              <Item icone={CHECK} texto="2 metas e 3 orçamentos" />
              <Item icone={CHECK} texto="Conexão automática com bancos" />
              <Item icone={CHECK} texto="Poucas atualizações manuais por dia" />
              <Item icone={CRUZ} texto="Compartilhar com outras pessoas" apagado />
              <Item icone={CRUZ} texto="Relatórios avançados e exportação" apagado />
            </div>
          </div>

          <div style={css('background: #131B2C; border: 2px solid #F5A623; border-radius: 16px; padding: 32px; display: flex; flex-direction: column; gap: 20px; position: relative;')}>
            <span style={css('position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #F5A623; color: #0B1220; font-size: 11px; font-weight: 800; padding: 4px 14px; border-radius: 999px;')}>MAIS POPULAR</span>
            <div>
              <div style={css('color: #FFFFFF; font-size: 18px; font-weight: 800;')}>{premium?.nome ?? 'Premium'}</div>
              <div style={css('color: #8892A8; font-size: 13px; margin-top: 4px;')}>Pra quem quer o controle completo, sem limites de conta.</div>
            </div>
            <div>
              <span style={css('color: #FFFFFF; font-size: 36px; font-weight: 800;')}>{precoPremium != null ? fmt(precoPremium) : '—'}</span>
              <span style={css('color: #6B7691; font-size: 13px;')}>{anual ? '/ano' : '/mês'}</span>
            </div>
            <Link to="/criar-conta" style={css('text-align: center; background: #F5A623; color: #0B1220; font-weight: 700; font-size: 14px; padding: 12px; border-radius: 9px; text-decoration: none;')}>Assinar Premium</Link>
            <div style={css('height: 1px; background: rgba(255,255,255,0.08);')} />
            <div style={css('display: flex; flex-direction: column; gap: 12px;')}>
              {[...FEATURES_PAGAS_BASE, 'Compartilhe com 1 pessoa'].map((f) => <Item key={f} icone={CHECK} texto={f} />)}
            </div>
          </div>

          <div style={css('background: #131B2C; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 32px; display: flex; flex-direction: column; gap: 20px;')}>
            <div>
              <div style={css('color: #FFFFFF; font-size: 18px; font-weight: 800;')}>{pro?.nome ?? 'Pro'}</div>
              <div style={css('color: #8892A8; font-size: 13px; margin-top: 4px;')}>Pra família grande ou quem administra mais contas junto.</div>
            </div>
            <div>
              <span style={css('color: #FFFFFF; font-size: 36px; font-weight: 800;')}>{precoPro != null ? fmt(precoPro) : '—'}</span>
              <span style={css('color: #6B7691; font-size: 13px;')}>{anual ? '/ano' : '/mês'}</span>
            </div>
            <Link to="/criar-conta" style={css('text-align: center; border: 1px solid rgba(255,255,255,0.18); color: #FFFFFF; font-weight: 700; font-size: 14px; padding: 12px; border-radius: 9px; text-decoration: none;')}>Assinar Pro</Link>
            <div style={css('height: 1px; background: rgba(255,255,255,0.08);')} />
            <div style={css('display: flex; flex-direction: column; gap: 12px;')}>
              {[...FEATURES_PAGAS_BASE, `Compartilhe com até ${pro?.maxCompartilhamentos ?? 5} pessoas`].map((f) => <Item key={f} icone={CHECK} texto={f} />)}
            </div>
          </div>

        </div>

        <p style={css('text-align: center; color: #4E5872; font-size: 12px; margin-top: 32px;')}>Preços em reais (BRL). Cancele quando quiser, direto nas configurações da sua conta.</p>
      </div>

      <Footer />
      <CookieBanner />
    </div>
  )
}
